import React from 'react';
import { LoadingIndicator } from '../shared/components/LoadingIndicator';

type Props = {
  children: React.ReactNode;
};

export function AppSuspense({ children }: Props) {
  return (
    <React.Suspense fallback={<LoadingIndicator />}>{children}</React.Suspense>
  );
}
